import * as React from 'react';

import { IWithContextProps, withContext } from '@tock/coretypes';
import { createMoneyFilter, currencyCodeToSymbol, isDecimalCurrency } from '@tock/money';
import BaseComponent from '../BaseComponent';
import TextInput from './DeprecatedTextInput';
import TextInputAffix from './TextInputAffix';

const filterWithDecimals = createMoneyFilter(2);
const filter = createMoneyFilter(0);
const filterWithDecimalsNegative = createMoneyFilter(2, true);
const filterNegative = createMoneyFilter(0, true);

interface Props<T> {
  'data-testid'?: string;
  id?: string;
  currency?: string;
  disabled?: boolean;
  allowNegative?: boolean;
  hideDecimals?: boolean;
  hidePrefix?: boolean;
  customPrefix?: JSX.Element | string;
  field: ReduxFormField<T>;
  modifierClassName?: string;
  onBlur?(event: React.FocusEvent<HTMLInputElement>): void;
  onChange?(event: React.ChangeEvent<HTMLInputElement>): void;
  onFocus?(event: React.FocusEvent<HTMLInputElement>): void;
  onClick?(eventOrValue: React.MouseEvent<HTMLInputElement>): void;
  placeholder?: string;
  ariaLabel?: string;
}

/**
 * @deprecated Prefer a Pantry component instead. See https://docs.tocktix.com/pantry.
 * If an equivalent component doesn't exist yet, reach out in #pantry-design-system on Slack.
 */
class PriceInput<T = string | number> extends BaseComponent<Props<T> & IWithContextProps> {
  render() {
    const {
      context: { currency: currencyFromContext },
      currency: currencyFromProps,
      hidePrefix,
      customPrefix,
      allowNegative,
      id,
    } = this.props;

    const currency = currencyFromProps || currencyFromContext;
    let prefix: JSX.Element | undefined;

    if (customPrefix) {
      prefix = <TextInputAffix text={customPrefix} />;
    } else if (currency && !hidePrefix) {
      prefix = <TextInputAffix disabled text={currencyCodeToSymbol(currency)} />;
    }

    const hideDecimals = isDecimalCurrency(currency) ? this.props.hideDecimals : true;
    let inputFilter = hideDecimals ? filter : filterWithDecimals;
    if (allowNegative) {
      inputFilter = hideDecimals ? filterNegative : filterWithDecimalsNegative;
    }
    return <TextInput {...this.props} id={id} filter={inputFilter} prefix={prefix} />;
  }
}

export default withContext(PriceInput);
